/* ============================================================
   Mini galeria en las tarjetas de producto.

   Lee data-pcg -una lista de URLs separadas por comas que escribe
   Liquid- y monta encima de la foto una tira deslizante con barra de
   progreso. Se pasan arrastrando, con el dedo o con el raton.

   Dos decisiones que importan:
   - No se descarga ninguna foto hasta que hace falta. En la posicion 0
     la tira esta oculta y quien se ve es la imagen que ya pinta el
     tema, asi que una pagina de coleccion con 24 productos no pide ni
     una peticion mas de lo que pedia antes.
   - La tarjeta se prepara cuando esta a punto de entrar en pantalla,
     no al cargar la pagina.
   ============================================================ */

(function () {
  var CHEVRON_IZQ = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
  var CHEVRON_DER = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';

  function montar(caja) {
    if (caja.dataset.pcgListo) return;
    caja.dataset.pcgListo = '1';

    var fotos = (caja.dataset.pcg || '').split(',').filter(Boolean);
    if (fotos.length < 2) return;

    // El marco es el contenedor que ya recorta la foto; si no lo
    // encontramos, la propia caja sirve.
    var marco = caja.querySelector('.sf__image-box') || caja.querySelector('.pp3r__link') || caja;
    if (marco.tagName === 'A') marco = marco.parentElement;
    marco.classList.add('pcg');

    var pista = document.createElement('div');
    pista.className = 'pcg__track';
    var imgs = [];
    fotos.forEach(function (src) {
      var img = document.createElement('img');
      img.className = 'pcg__img';
      img.alt = '';
      img.decoding = 'async';
      img.dataset.src = src;
      imgs.push(img);
      pista.appendChild(img);
    });

    var ant = document.createElement('button');
    ant.type = 'button';
    ant.className = 'pcg__nav pcg__nav--ant';
    ant.setAttribute('aria-label', 'Foto anterior');
    ant.innerHTML = CHEVRON_IZQ;

    var sig = document.createElement('button');
    sig.type = 'button';
    sig.className = 'pcg__nav pcg__nav--sig';
    sig.setAttribute('aria-label', 'Foto siguiente');
    sig.innerHTML = CHEVRON_DER;

    var rail = document.createElement('div');
    rail.className = 'pcg__rail';
    var thumb = document.createElement('span');
    thumb.className = 'pcg__thumb';
    thumb.style.width = (100 / fotos.length) + '%';
    rail.appendChild(thumb);

    marco.appendChild(pista);
    marco.appendChild(ant);
    marco.appendChild(sig);
    marco.appendChild(rail);

    var i = 0;

    function cargar(n) {
      var img = imgs[(n + fotos.length) % fotos.length];
      if (img && img.dataset.src) {
        img.src = img.dataset.src;
        delete img.dataset.src;
      }
    }

    function ir(n) {
      i = (n + fotos.length) % fotos.length;
      // La actual y la de al lado, para que el salto no se vea en blanco
      cargar(i);
      cargar(i + 1);
      cargar(i - 1);
      pista.style.transform = 'translateX(' + (-i * 100) + '%)';
      thumb.style.transform = 'translateX(' + (i * 100) + '%)';
      marco.classList.toggle('pcg--activa', i > 0);
    }

    // ---- Pasar fotos sin flechas ----
    // Con raton, arrastrar una imagen dentro de un enlace dispara el
    // arrastre nativo del navegador: aparece la miniatura fantasma, se
    // cancela el puntero y el pointerup no llega nunca. Por eso hay que
    // desactivar ese arrastre y capturar el puntero.
    marco.addEventListener('dragstart', function (e) { e.preventDefault(); });

    var x0 = null;
    var y0 = null;
    var arrastro = 0;

    marco.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      x0 = e.clientX;
      y0 = e.clientY;
    });

    // Ojo con dos cosas que rompen el enlace de la tarjeta:
    //   - capturar el puntero en el marco hace que el click se dispare en el
    //     marco y no en el <a> de dentro, asi que la foto dejaba de llevar
    //     al producto;
    //   - cancelar el pointerdown suprime el click de compatibilidad.
    // Por eso no se hace ninguna de las dos: el pointerup se escucha en la
    // ventana, que cubre el caso de soltar fuera de la foto.
    window.addEventListener('pointerup', function (e) {
      if (x0 === null) return;
      var dx = e.clientX - x0;
      var dy = e.clientY - y0;
      x0 = null;
      // Un gesto mas vertical que horizontal es un scroll, no un pase
      if (Math.abs(dx) < 35 || Math.abs(dy) > Math.abs(dx)) return;
      arrastro = Date.now();
      ir(i + (dx < 0 ? 1 : -1));
    });

    marco.addEventListener('pointercancel', function () { x0 = null; });

    // Las flechas vuelven por peticion de direccion de arte. Marcan
    // arrastro para que el click no abra ademas la ficha del producto.
    function pulsar(e, paso) {
      e.preventDefault();
      e.stopPropagation();
      arrastro = Date.now();
      ir(i + paso);
    }

    ant.addEventListener('click', function (e) { pulsar(e, -1); });
    sig.addEventListener('click', function (e) { pulsar(e, 1); });

    // Solo se anula el click cuando viene de un arrastre; un click normal
    // tiene que entrar al producto.
    marco.addEventListener('click', function (e) {
      if (Date.now() - arrastro < 400) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    // La propia barra sirve de mando: se pulsa o se recorre con el raton
    // y salta a esa foto. Es el unico gesto visible que queda, asi que
    // conviene que responda.
    function desdeBarra(e) {
      var r = rail.getBoundingClientRect();
      var n = Math.floor(((e.clientX - r.left) / r.width) * fotos.length);
      if (n < 0) n = 0;
      if (n > fotos.length - 1) n = fotos.length - 1;
      if (n !== i) ir(n);
    }

    rail.addEventListener('pointerdown', function (e) {
      e.preventDefault();
      e.stopPropagation();
      arrastro = Date.now();
      desdeBarra(e);
    });

    rail.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      desdeBarra(e);
    });
  }

  function preparar(raiz) {
    var cajas = (raiz || document).querySelectorAll('[data-pcg]:not([data-pcg-listo])');
    if (!cajas.length) return;

    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(cajas, montar);
      return;
    }

    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (en) {
        if (!en.isIntersecting) return;
        obs.unobserve(en.target);
        montar(en.target);
      });
    }, { rootMargin: '300px' });

    Array.prototype.forEach.call(cajas, function (c) { obs.observe(c); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { preparar(); });
  } else {
    preparar();
  }

  // Las rejillas se repintan al filtrar, al paginar y al cargar mas:
  // las tarjetas nuevas tienen que engancharse solas.
  var pendiente = false;
  new MutationObserver(function () {
    if (pendiente) return;
    pendiente = true;
    requestAnimationFrame(function () {
      pendiente = false;
      preparar();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
